
















import {Component, Prop, Vue} from 'vue-property-decorator'
import {TokenCollection} from '@/model/collection/TokenCollection'
import {FilterTokenSchema} from '@/schema/resource/Token/FilterTokenSchema'

@Component
export default class FilterToken extends Vue {
  @Prop({type: Object, required: true}) collection!: TokenCollection

  schema = new FilterTokenSchema()

  async created() {
    await this.populateFilterOptions()
  }

  async populateFilterOptions() {
    this.collection.resource = this.schema

    const promises: Array<Promise<any>> = []

    await this.$await.run('softQuery', () => Promise.all(promises))
  }

  async doFilter() {
    this.$emit('submit')
    await this.$await.run('softQuery', () => this.collection.queryAsPage())
  }
}
